<template>
    <form class="form-horizontal" v-if="config">
        <div class="form-group">
            <label for="usuario" class="col-sm-2 control-label">Modo:</label>
            <div class="col-sm-1">
                <select v-model="config.server1_mode_gprs" class="form-control">
                    <option value="1">FIFO</option>
                    <option value="0">LIFO</option>
                </select>
            </div>
            <label for="usuario" class="col-sm-1 control-label">IP / DNS:</label>
            <div class="col-sm-4">
                <input type="text" v-model="config.server1_ip" class="form-control" id="usuario">
            </div>
            <label for="senha" class="col-sm-1 control-label">PORTA</label>
            <div class="col-sm-2">
                <input type="text" v-model="config.server1_port"  class="form-control" id="senha" >
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <button @click="send()" type="button" class="btn btn-sm btn-success">
                    <i class="fa fa-save"></i> ENVIAR CONFIGURAÇÃO
                </button>
            </div>
        </div>
    </form>
</template>
<script>
    import { Bus } from '../../../../class/bus';
    import { Vitana } from '../../../../class/vitana';
    export default {
        name: "IpVitana",
        props: {
            config: {
                "default": null
            }
        },
        methods: {
            send () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Vitana.sendIp(this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.log(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            }
        }
    }
</script>
